<template>
  <div class="login">
    <div class="login-left">
      <div class="logo-text">火眼 —— 移动广告监测工具</div>
    </div>
    <div class="login-box">
      <router-view />
    </div>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "Auth",
};
</script>

<style lang="less" scoped>
.login {
  min-height: 100vh;
  display: flex;
  .login-left {
    width: 500px;
    background: #0093ff;
    position: relative;

    .logo-text {
      text-align: center;
      position: absolute;
      top: 50%;
      font-size: 32px;
      font-weight: 600;
      left: 40px;
      color: #fff;
    }
  }
  .login-box {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    .login-form {
      width: 340px;
      text-align: left;
      .btns {
        margin-bottom: 20px;
        a {
          text-decoration: none;
          padding: 5px 10px;
          color: #000;
          font-weight: 600;
        }
        .active {
          border-bottom: 2px solid #0093ff;
        }
      }
      .form {
        .el-button {
          padding: 8px 40px;
          margin-right: 20px;
        }
        .forget {
          text-decoration: none;
          font-weight: 600;
          font-size: 12px;
          color: #000;
        }
      }
    }
  }
}
</style>